import { render, staticRenderFns } from "./CNotificationContainer.vue?vue&type=template&id=81f48f10"
import script from "./CNotificationContainer.vue?vue&type=script&lang=js"
export * from "./CNotificationContainer.vue?vue&type=script&lang=js"
import style0 from "./CNotificationContainer.vue?vue&type=style&index=0&id=81f48f10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports